import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { SortValueEnum } from './enums/top-bar.enum';

@Component({
  selector: 'tic-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent {
  @Input() selectedAmountSort: string = SortValueEnum.TotalAmountAsc;
  @Input() selectedDurationSort: string = SortValueEnum.TotalDurationAsc;
  @Output() sortValue: EventEmitter<SortValueEnum> = new EventEmitter();
  sortValueEnum = SortValueEnum;
  
  onAmountSortChange(event: MatSelectChange): void {
    this.selectedAmountSort = event.value;
    this.sortValue.emit(event.value);
  }

  onDurationSortChange(event: MatSelectChange): void {
    this.selectedDurationSort = event.value;
    this.sortValue.emit(event.value);
  }
}
